import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { CustomerOrdersDesktopComponent } from '@app/pages/pages-auth/customer-orders/customer-orders-desktop/customer-orders-desktop.component';
import { CustomerOrdersMobileComponent } from '@app/pages/pages-auth/customer-orders/customer-orders-mobile/customer-orders-mobile.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-customer-orders',
  standalone: true,
  imports: [CommonModule, CustomerOrdersDesktopComponent, CustomerOrdersMobileComponent],
  templateUrl: './customer-orders.component.html',
  styleUrl: './customer-orders.component.scss',
})
export class CustomerOrdersComponent implements OnInit {
  screenSize!: string;

  private routeSub!: Subscription;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // feature - auto-login from public order page to auth order page

    // if (!!this.authService.user.value) {
    //   this.routeSub = this.route.params.subscribe((params) => {
    //     const customerOrderId: string = params['id'];

    //     this.router.navigate(['/customer/customer-order/' + customerOrderId]);
    //   });
    // }

    this.screenSize = this.route.snapshot.data['screenSize'];
  }
}
